/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2019, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS 'AS IS' AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'

import {
  NavLink,
  DateTime
} from '../'

import {
  Progress
} from './Progress'


const getProgressSteps = (requestRun) => {
  const { createdAt, createdBy, isAllocated, capturedBy, validatedBy, validatedAt, isProcessed, updatedAt, identity, requesttype, workflowrunProcessing, status, sources } = requestRun

  const requestCreator = createdBy
    ? createdBy.identity
      ? createdBy.identity.fullName
      : createdBy.username  // created by system user
    : "Unknown"

  let progressSteps = [
    {
      description: `Request created by ${requestCreator}`,
      date: <DateTime>{createdAt}</DateTime>
    },
    {
      description: `Classified as ${requesttype.name}`,
      date: null
    }
  ]

  if (sources.length > 0) {
    progressSteps.unshift({
      description: 'File received via Email',
      date: sources[0].createdAt
        ? <DateTime>{sources[0].createdAt}</DateTime>
        : null
    })
  }

  if (isAllocated) {
    progressSteps.push({
      description: `Allocated to ${identity.fullName}${requesttype.allocateTo ? ` (${requesttype.allocateTo.model})` : ''}`,
      date: null
    })
  }

  if (capturedBy) {
    progressSteps.push({
      description: `Captured by ${capturedBy.fullName}`
    })
  }

  if (validatedBy) {
    progressSteps.push({
      description: `Validated by ${validatedBy.fullName}`,
      date: <DateTime>{validatedAt}</DateTime>
    })
  }

  if (workflowrunProcessing) {
    progressSteps.push({
      description: 'Workflow created',
      date: <DateTime>{workflowrunProcessing.createdAt}</DateTime>
    })

    if (isProcessed) {
      progressSteps.push({
        description: 'Workflow processed',
        date: <DateTime>{workflowrunProcessing.processedAt}</DateTime>
      })
    }
  }

  if (status.includes('CLOSED_') || status === 'PROCESSED') {
    progressSteps.push({
      description: status.includes('CLOSED_')
        ? 'Request cancelled'
        : 'Request processing complete',
      date: <DateTime>{updatedAt}</DateTime>
    })
  }

  return progressSteps
}


export class RequestProcessingSummary extends React.Component {
  static propTypes = {
    requestRun: PropTypes.shape({
      createdAt: PropTypes.string.isRequired,
      createdBy: PropTypes.shape({
        username: PropTypes.string,
        identity: PropTypes.shape({
          fullName: PropTypes.string
        })
      }).isRequired,
      validatedAt: PropTypes.string.isRequired,
      capturedBy: PropTypes.shape({
        fullName: PropTypes.string.isRequired
      }),
      validatedBy: PropTypes.shape({
        fullName: PropTypes.string.isRequired
      }),
      identity: PropTypes.shape({
        fullName: PropTypes.string.isRequired
      }),
      requesttype: PropTypes.shape({
        name: PropTypes.string,
        allocateTo: PropTypes.string
      }).isRequired,
      sources: PropTypes.arrayOf(
        PropTypes.shape({
          createdAt: PropTypes.string.isRequired
        })
      ),
      workflowrunProcessing: PropTypes.shape({
        createdAt: PropTypes.string.isRequired,
        processedAt: PropTypes.string
      })
    }).isRequired,
    className: PropTypes.string
  }

  render() {
    return (
      <section className={this.props.className}>
        <div className='u-font-size-x-large slds-m-bottom_medium'>Summary</div>
        <Progress steps={getProgressSteps(this.props.requestRun)} />
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/request-processing-summary/index.js